import { authConstants, userConstants } from '../constants';
import { redirect } from '../helper';
import { UserActions } from '../actions';
import { AuthApi } from '../services';

export class AuthActions {
    static login (data, redirectData) {
        return (dispatch) => {
            dispatch({type: authConstants.LOGIN_REQUEST, payload: {...data}});

            AuthApi.login(data)
                .then((res) => res.json())
                .then((res) => {
                    // success
                    if(res.meta.success === true) {
                        dispatch({type: authConstants.LOGIN_SUCCESS});  
                        
                        const rdr = redirectData ? `${redirectData.pathname}${redirectData.search}`: './';
                        dispatch(UserActions.getData());
                        redirect(rdr); // redirect original user (page) request

                        return;
                    }

                    // another validation error
                    return dispatch({type: authConstants.LOGIN_FAILURE});
                })
                .catch((err) => {
                    dispatch({type: authConstants.LOGIN_FAILURE});
                });
        }
    }

    static logout () {
        return (dispatch) => {
            dispatch({type: authConstants.LOGOUT_REQUEST});
            
            AuthApi.logout()
                .then((res) => {
                    dispatch({type: authConstants.LOGOUT_SUCCESS});
                }).catch((err) => {
                    dispatch({type: authConstants.LOGOUT_FAILURE});
                });
        }
    }

    /**
     * check if user logged in by request to get user data
     */
    static isUserLoggedIn () {
        return (dispatch) => {
            dispatch({type: authConstants.AUTH_REQUEST});

            AuthApi.isUserLoggedIn()
                .then((res) => {

                    // if user not logged in
                    if(res.status === 403) {
                        dispatch({type: authConstants.AUTH_FAILURE});
                    } 

                    return res.json();
                })
                .then((res) => {
                    // success
                    if(res.meta.success === true) {
                        dispatch({type: authConstants.AUTH_SUCCESS, payload: {...res.meta}})

                        // update user store data
                        dispatch({type: userConstants.GET_USER_DATA_SUCCESS, payload: {...res.data}});
                        return;
                    }

                    return dispatch({type: authConstants.AUTH_FAILURE});
                })
                .catch((err) => {
                    dispatch({type: authConstants.AUTH_FAILURE});
                });
        }
    }
}


// WEBPACK FOOTER //
// ./src/actions/auth.js